import React, { useEffect, useState } from 'react'
import { useAuth } from '../../helpers/authContext';
import { Loading } from 'daymap-library';
import styles from './StudentPhoto.module.scss';
import userImg from '../../assets/user.png';

function StudentPhoto({ID, className}){
    const imageURL = useStudentPhotoUrl(ID);
    const classNames = [styles.StudentPhoto];

    className && classNames.push(className);

    if(imageURL ===null)
        return <Loading />
        
    return (<div style={{backgroundImage: `url(${imageURL})`}} className={classNames.join(' ')}></div>)
}

const useStudentPhotoUrl = studentId => {
    const [url, setUrl] = useState(null);
    const { lmsFetch } = useAuth();

    const getImageData = async () => {
        let imageSrc ="";
        try {
            const [photodata,cancel] = lmsFetch(`/lms/api/checkin/studentPhoto?StudentID=${studentId}`, null, {returns: 'raw'});
            const response = await photodata();
            var responseType = response.headers.get("content-type");
    
            if(responseType.includes('text/plain')){
                await response.text().then(function(text) {
                    imageSrc = text;        
                });
            }else{
                await response.blob().then(function(blob) {
                    imageSrc = URL.createObjectURL(blob);        
                });          
            }
        } catch (error) {
            console.log('Error getting student photo', error);
            imageSrc = userImg;
        }
        
        setUrl(imageSrc);
    }

    useEffect(() => {
        getImageData();
    }, [studentId]);

    return url;
}

export default StudentPhoto;
export { useStudentPhotoUrl}